export default __webpack_public_path__ + "static/media/banner1.efe5906a.jpeg";